import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';
import fileExport from '@/utils/fileExportForGet';
import fileExport1 from '@/utils/fileExport';
import notify from '@/utils/notify.js';
// 企业赔付列表
export const claimQueryList=data=>{
    return http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectPaidDataHr',data)
}

// 文件下载
export const downloadTemplate=data=>{
    return fileExport('模板.xlsx',data,'/api/upload/download',)
}

// 数据概览
export const selectOverviewHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectOverviewHr',data,{ noLoading: true })
// 赔付分析
export const selectAnalysisHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectAnalysisHr',data,{ noLoading: true })
// 企业赔付数据起始时间
export const selectStartDateHr=data=>http.Axios.get(rootPath+'/api/enterprisePaidDataHr/selectStartDateHr',{
    params: data,
    noLoading: true,
})
// 明细报表
export const selectReportsHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectReportsHr',data,{ noLoading: true })
// 明细报表导出
export const exportReportsHr=(fileName, data = {}) =>fileExport1(fileName,data,'/api/enterprisePaidDataHr/exportReportsHr')
// 企业健康分
export const enterprisePaidDataHrselectHealthScoreHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectHealthScoreHr',data)
//蓝湖就诊相关接口
export const enterprisePaidDataHrselectSeeDoctorDataHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectSeeDoctorDataHr',data)
//蓝湖后五个接口
export const enterprisePaidDataHrselectAnalysisHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectAnalysisHr',data)
// 查询在线理赔信息

export const selectPaidDataInfoHr=data=>http.Axios.post(rootPath+'/api/enterprisePaidDataHr/selectPaidDataInfoHr',data)
// pc导出员工健康报告

export const exportPDF=data=>fileExport1('员工健康报告.pdf',data,'/api/enterprisePaidDataHr/pc/exportPDF')

